import type { ApiError } from '@approvalmax/types';
import { routerHelpers } from '@approvalmax/utils';
import { useQuery } from '@tanstack/react-query';
import { domain } from 'modules/data';
import { routingService } from 'services/routing';
import { getPath, Path } from 'urlBuilder';

import { loadOneRequest } from '../actions';
import { QueryKeys } from '../config';

const useOldRequestsSupportingPageData = () => {
    const requestId = routerHelpers.getParamAsString(location.search, 'id', '');

    return useQuery<domain.Request, ApiError>(
        [QueryKeys.OldRequestsSupportingPageData, requestId],
        async () => {
            const oneRequestResponse = await loadOneRequest(requestId);

            if (!oneRequestResponse) {
                throw Error('Request not found');
            }

            return oneRequestResponse.request;
        },
        {
            retry: false,
            onSuccess: (request) => {
                routingService.replace(getPath(Path.request, request.id, request.companyId));
            },
        }
    );
};

export default useOldRequestsSupportingPageData;
